/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeourconferences2Inputs */



/**
* | output |
* | --- |
* | "Our conferences" |
*
* @param {Homeourconferences2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeourconferences2 = /** @type {((inputs?: Homeourconferences2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeourconferences2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Our conferences")
	return /** @type {LocalizedString} */ ("Unsere Konferenzen")
});
export { homeourconferences2 as "homeOurConferences" }